export const logo = require("../imgs/logo.png");
export const company_logo = require("../imgs/company-logo.png");
export const knf_logo = require("../imgs/KNF-Logo.png");
export const knf_main_logo = require("../imgs/knf_main_logo.png");
export const profile = require("../imgs/profile-icon.png");
export const user_icon = require("../imgs/admin-icon.png");
export const user_img = require("../imgs/user.png");
export const user_act = require("../imgs/admin-act.png");
export const device_icon = require("../imgs/device-icon.png");
export const device_act = require("../imgs/device-act.png");
export const location_icon = require("../imgs/location-icon.png");
export const location_act = require("../imgs/location-act.png");
export const toggle_on = require("../imgs/toggle-on.png");
export const toggle_off = require("../imgs/toggle-off.png");
export const logout_icon = require("../imgs/logout-icon.png");
export const company_icon = require("../imgs/company-icon.png");
export const mobile_icon = require("../imgs/mobile-icon.png");
export const email_icon = require("../imgs/email-icon.png");
export const password_icon = require("../imgs/password-icon.png");
export const delete_icon = require("../imgs/delete-icon.png");
export const edit_icon = require("../imgs/edit-icon.png");
export const eye_icon = require("../imgs/eye_icon.png");
export const view_icon = require("../imgs/view-icon.png");
export const company_role = require("../imgs/company-role.png");
export const dummyimage = require("../imgs/dummyimage.png");
export const search_icon = require("./search-icon.png");
export const user = require("./user.png");
export const merch_toggle_on = require("./merch_toggle.png");
export const merch_toggle_off = require("./merch_toggle_off.png");
export const red_icon = require("./red_icon.png");
export const green_icon = require("./green_icon.png");
export const construction = require("./construction.jpg");
export const aiware_logo_png = require("./AI-WARE-LOGO-PNG.png");
export const aiware_logo = require("./AI-WARE-LOGO.png");
export const knfLogo = require("./knfLoginLogo.png");
